import PhotoSwipe from './photoswipe.esm.js';

function getGalleryItems(gallery) {
  const links = Array.from(gallery.querySelectorAll('[data-product-photoswipe-item]'));

  return links
    .filter((link) => {
      return (
        link.getAttribute('data-pswp-src') &&
        link.getAttribute('data-pswp-width') &&
        link.getAttribute('data-pswp-height')
      );
    })
    .map((link) => {
      return {
        src: link.getAttribute('data-pswp-src'),
        width: Number(link.getAttribute('data-pswp-width')),
        height: Number(link.getAttribute('data-pswp-height')),
        alt: link.getAttribute('aria-label') || ''
      };
    });
}

function initProductPhotoSwipe(root = document) {
  const galleries = root.querySelectorAll('[data-product-photoswipe-gallery]');

  galleries.forEach((gallery) => {
    if (gallery.dataset.photoswipeInitialised === 'true') return;

    gallery.addEventListener(
      'click',
      function (event) {
        const trigger = event.target.closest('[data-product-photoswipe-item]');

        if (!trigger || !gallery.contains(trigger)) return;

        event.preventDefault();
        event.stopPropagation();

        const triggers = Array.from(gallery.querySelectorAll('[data-product-photoswipe-item]'));
        const index = triggers.indexOf(trigger);
        const items = getGalleryItems(gallery);

        if (!items.length || index < 0) return;

        const pswp = new PhotoSwipe({
          dataSource: items,
          index,
          bgOpacity: 0.82,
          showHideAnimationType: 'fade',
          wheelToZoom: true,
          paddingFn: (viewportSize) => {
            const isMobile = viewportSize.x < 750;

            return {
              top: isMobile ? 24 : 56,
              bottom: isMobile ? 24 : 56,
              left: isMobile ? 14 : 48,
              right: isMobile ? 14 : 48
            };
          }
        });

        pswp.on('beforeOpen', () => {
          document.documentElement.classList.add('product-photoswipe-open');
          document.body.classList.add('product-photoswipe-open');
        });

        pswp.on('close', () => {
          document.documentElement.classList.remove('product-photoswipe-open');
          document.body.classList.remove('product-photoswipe-open');
        });

        pswp.init();
      },
      true
    );

    gallery.dataset.photoswipeInitialised = 'true';
  });
}

initProductPhotoSwipe();

document.addEventListener('shopify:section:load', function (event) {
  initProductPhotoSwipe(event.target);
});

const observer = new MutationObserver(() => {
  window.requestAnimationFrame(() => {
    initProductPhotoSwipe();
  });
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true
});